import { graphql } from '@/client/services/api/graphql/gql';

export const updateAnnouncementMutation = graphql(`
  mutation UpdateAppAnnouncement($id: String!, $input: AppAnnouncementUpdateInput!) {
    updateAppAnnouncement(id: $id, input: $input) {
      id
      title
      content
      routes
      published
      publishedAt
      createdAt
    }
  }
`);
